import React from 'react';
import errorReporting from './common/errorReporting'
import Config from 'Config'

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false
        }
    }

    componentDidCatch(error, errorInfo) {
        console.log('Unexpected fatal Error', error);

        const crashReportingEnabled = Config.crashReporting.enabled || false;
        const env = location.hostname || '';
        if (crashReportingEnabled) {
            errorReporting.reportError('Error in ' + env + ': ' + error, errorInfo.componentStack);
        }

        this.setState({
            hasError: true
        });
    }

    render() {
        if (this.state.hasError) {
            return (
                <h1>Something Unexpected happened!</h1>
            )
        }

        return this.props.children;
    }
}

export default ErrorBoundary;